// Thin frontend wrapper around the booking API endpoints.

export async function fetchAvailability({ start, end }) {
  const url = `/api/ownerrez-availability?start=${start}&end=${end}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`availability ${res.status}`);
  return res.json();
}

export async function fetchQuote({ arrival, departure, adults, children, discountCode }) {
  const res = await fetch('/api/ownerrez-quote', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ arrival, departure, adults, children, discountCode })
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `quote ${res.status}`);
  }
  return res.json();
}

// Path A: create the guest + real quote server-side and get back the OwnerRez
// hosted payment-form URL. The caller redirects the browser there; OwnerRez
// collects the card and creates the booking (the App API can't do that itself).
export async function startBooking(payload) {
  const res = await fetch('/api/ownerrez-book', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `booking ${res.status}`);
  }
  return res.json();
}

export async function fetchBooking(sessionId) {
  const res = await fetch(`/api/get-booking?session_id=${sessionId}`);
  if (!res.ok) throw new Error(`get-booking ${res.status}`);
  return res.json();
}
